var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreezer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 1.875H5.37915C4.68879 1.875 4.12915 2.43464 4.12915 3.125V15.8667C4.12915 16.557 4.68879 17.1167 5.37915 17.1167H14.625C15.3153 17.1167 15.875 16.557 15.875 15.8667V3.125C15.875 2.43464 15.3153 1.875 14.625 1.875Z",
    stroke: "#101828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12915 8.20416H15.8708M6.44582 6.60416V4.07916M6.44582 12.15V9.625M5.26665 17.1167V17.5542C5.26665 17.7048 5.32622 17.8494 5.43237 17.9563C5.53852 18.0633 5.68265 18.1239 5.83332 18.125H6.86248C7.01388 18.125 7.15907 18.0649 7.26612 17.9578C7.37318 17.8507 7.43332 17.7056 7.43332 17.5542V17.1167M12.5625 17.1167V17.5542C12.5625 17.7056 12.6226 17.8507 12.7297 17.9578C12.8367 18.0649 12.9819 18.125 13.1333 18.125H14.1667C14.318 18.125 14.4632 18.0649 14.5703 17.9578C14.6773 17.8507 14.7375 17.7056 14.7375 17.5542V17.1167",
    stroke: "#101828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezer);
export default __webpack_public_path__ + "static/media/freezer.cc3b504ec8e74c63e7db444cce329b81.svg";
export { ForwardRef as ReactComponent };